import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=4ebd5984&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=4ebd5984&lang=scss&scoped=true&"
import style1 from "./Edit.vue?vue&type=style&index=1&id=4ebd5984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebd5984",
  null
  
)

export default component.exports